import React from 'react'

const NotFound = () => {
  return <div>There's nothing here...</div>
}

export default NotFound
